import React, { useState } from 'react';
import Card from '../layout/Card';

const InfoGeoItem = ({ item, item_i, showDetail, setShowDetail }) => {

    return (
        <>

            <Card>
                <button onClick={() => setShowDetail(showDetail == item_i ? null : item_i)} className='df aic jcsb w100 cp'>
                    <p className='cw fr '>{item.country}</p>
                    <p className='cw fb fs18'>{item.total}</p>
                </button>
            </Card>

            {showDetail == item_i && (
                <div className='py1'>
                    <Card>
                        {item.regions.map((region, region_i) => (
                            <div key={item_i + "geto_detail" + region_i} className='mb1'>

                                <div className='df aic mb1 jcsb w100'>
                                    <p className='cw fl fs13 '>{region.name}</p>
                                    <p className='cw fb fs18'>{region.count}</p>
                                </div>

                            </div>
                        ))}
                    </Card>
                </div>
            )}
        </>
    );
};

export default InfoGeoItem;